import { SLICE_NAME } from "../../model/types/types";

export const ActionType = {
  UPDATE_CHAT: `${SLICE_NAME}/update_chat`,
  DELETE_CHAT: `${SLICE_NAME}/delete_chat`,
  RETRIEVE_CHAT: `${SLICE_NAME}/get_chat`,
  RETRIEVE_MANY_CHATS: `${SLICE_NAME}/get_many_chats`,
  SEND_MESSAGE_AUTHORIZED: `${SLICE_NAME}/send_message_authorized`,
} as const;
